/**
 * A whole-second span as the parts a running clock prints: the whole HOURS, counted on past a day rather than rolled
 * into one, the MINUTES within the hour and the SECONDS within the minute. The one spelling of the split the partner
 * clock, the call clock and the auction countdown each did by hand; how each prints the parts stays its own.
 *
 * @runtime-derived-ssot-helper (const-leaf-pinned): pure over `TIME_UNITS`, homed in const/ so every layer reaches it.
 */

import { TIME_UNITS } from './time-units.ts';

/** The hours/minutes/seconds split of a whole-second span.
 *  @runtime-derived-ssot-helper (utils-floor-pinned): `utils/dates/format-countdown.ts` value-binds it, and the
 *  same-leaf {@link countdownClockParts} composes it. */
export function elapsedClockParts(totalSeconds: number): { readonly hours: number; readonly minutes: number; readonly seconds: number } {
	return {
		hours: Math.floor(totalSeconds / TIME_UNITS.HOUR_S),
		minutes: Math.floor((totalSeconds % TIME_UNITS.HOUR_S) / TIME_UNITS.MINUTE_S),
		seconds: totalSeconds % TIME_UNITS.MINUTE_S,
	};
}

/**
 * The COUNTDOWN split of a span: whole DAYS first, then the HOURS within the day, the minutes and the seconds -- the
 * split the auction flip clock, the auction countdown label and the remaining-time helper each did by hand. A fractional
 * second is dropped first; for a non-negative span that changes no part but the seconds.
 * @runtime-derived-ssot-helper (const-leaf-pinned): the one day-rolled split.
 */
export function countdownClockParts(totalSeconds: number): {
	readonly days: number;
	readonly hours: number;
	readonly minutes: number;
	readonly seconds: number;
} {
	const whole = Math.floor(totalSeconds);
	const { minutes, seconds } = elapsedClockParts(whole);
	return { days: Math.floor(whole / TIME_UNITS.DAY_S), hours: Math.floor((whole % TIME_UNITS.DAY_S) / TIME_UNITS.HOUR_S), minutes, seconds };
}
